import { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'all');
    setVisible(false);
    if (window.gtag) window.gtag('consent', 'update', { analytics_storage: 'granted' });
  };

  const refuse = () => {
    localStorage.setItem('cookie_consent', 'essential');
    setVisible(false);
    if (window.gtag) window.gtag('consent', 'update', { analytics_storage: 'denied' });
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      padding: '18px 28px',
      background: 'rgba(248,250,252,0.97)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      borderTop: '1px solid rgba(220,227,234,.9)',
      boxShadow: '0 -8px 30px rgba(11,31,58,.05)',
    }}>
      <div style={{
        maxWidth: 1200, margin: '0 auto',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 20, flexWrap: 'wrap',
      }}>
        <p style={{ margin: 0, fontSize: '0.92rem', color: '#45607c', maxWidth: 560, lineHeight: 1.55 }}>
          Ce site utilise des cookies pour améliorer l'expérience et analyser le trafic.{' '}
          <a href="/privacy" style={{ color: '#67c9b2', textDecoration: 'underline', textUnderlineOffset: 3 }}>
            En savoir plus
          </a>
        </p>
        <div style={{ display: 'flex', gap: 12, flexShrink: 0 }}>
          <button
            onClick={refuse}
            style={{
              padding: '10px 18px', borderRadius: 999, border: '1px solid rgba(220,227,234,.9)',
              background: 'transparent', color: '#45607c', fontSize: '0.9rem', fontWeight: 500,
              cursor: 'pointer', fontFamily: "'Inter Tight', sans-serif",
              transition: 'all .25s',
            }}
          >
            Refuser
          </button>
          <button
            onClick={accept}
            style={{
              padding: '10px 18px', borderRadius: 999, border: 'none',
              background: '#7ED6C1', color: '#0B1F3A', fontSize: '0.9rem', fontWeight: 600,
              cursor: 'pointer', fontFamily: "'Inter Tight', sans-serif",
              boxShadow: '0 6px 18px rgba(126,214,193,.2)',
              transition: 'all .25s',
            }}
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
